export default function setPermission(state, permissions) {
  state.permissions = permissions
}

export function setPermissions(state, permissions) {
  state.permissions = permissions
}
